import { CARD_VARIANT, ILandingCard } from "@shared/components/card/types";
import { FC } from "react";
import LandingCard from "./landingCard";
import { FAVORITE_TYPE } from "enums/favorite-type";

const ExploreLandingCard: FC<ILandingCard> = (props) => {
  return (
    <>
      <div className="sm:hidden block">
        <LandingCard
          {...props}
          title={props.title_short || props.title}
          variant={CARD_VARIANT.LIST}
          hugElement={true}
          noBorder={true}
          favoriteType={FAVORITE_TYPE.HOW_TO_LEARN}
        />
      </div>
      <div className="hidden sm:block">
        <LandingCard
          {...props}
          title={props.title_short || props.title}
          variant={CARD_VARIANT.GRID}
          noBorder={false}
          hugElement={false}
          favoriteType={FAVORITE_TYPE.HOW_TO_LEARN}
        />
      </div>
    </>
  );
};
export default ExploreLandingCard;
